import { PieChartOutlined, ShopOutlined, StockOutlined, UploadOutlined, UserOutlined, CarOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";

export const menuItems = [
    {
        key: '1',
        icon: <PieChartOutlined />,
        label: <NavLink to="/">Ko'rsatgichlar</NavLink>,
    },
    {
        key: '/kontragents',
        icon: <UserOutlined />,
        label: <NavLink to="/kontragents">Kontragentlar</NavLink>,
        children: [
            {
                key: '/customers',
                label: <NavLink to="/customers">Mijozlar</NavLink>,
            },
            {
                key: '/suppliers',
                label: <NavLink to="/suppliers">Sotuvchilar</NavLink>,
            },
            {
                key: '/transactions',
                label: <NavLink to="/transactions">Tranzaksiyalar</NavLink>,
            }
        ]
    },
    {
        key: '/posmain',
        icon: <ShopOutlined />,
        label: "Sotuvlar",
        children: [
            {
                key: '/pos',
                label: <NavLink to="/pos">Pos</NavLink>,
            },
            {
                key: '/pos/history',
                label: <NavLink to="/pos/history">Pos tarixi</NavLink>,
            },
            {
                key: '/pos/products',
                label: <NavLink to="/pos/products">Mavjud tovarlar</NavLink>,
            },
            {
                key: '/pos/expences',
                label: <NavLink to="/pos/expences">Xarajatlar</NavLink>,
            },
            {
                key: '/pos/report',
                label: <NavLink to="/pos/report">Xisobotlar</NavLink>,
            },
            // {
            //     key: '/pos/shopitems',
            //     label: <NavLink to="/pos/shopitems">Magazindagi tovarlar</NavLink>,
            // },
        ]
    },
    {
        key: '/sklad',
        icon: <StockOutlined />,
        label: <NavLink to="/sklad">Sklad</NavLink>,
        children: [
            {
                key: '/params/warehouses',
                label: <NavLink to="/params/warehouses">Skladlar</NavLink>,
            },
            {
                key: '/income/coming',
                label: <NavLink to="/income/coming">Kirim</NavLink>,
            },
            {
                key: '/income/history',
                label: <NavLink to="/income/history">Kirimlar tarixi</NavLink>,
            },
            {
                key: '/sklad/products',
                label: <NavLink to="/sklad/products">Maxsulotlar</NavLink>,
            },
            {
                key: '/sklad/btsconfigs',
                label: <NavLink to="/sklad/btsconfigs">BTS Konfiguratsiyalari</NavLink>,
            },
            {
                key: '/income/sell',
                label: <NavLink to="/income/sell">Inventarizatsiya</NavLink>,
            },
            {
                key: '/income/prices',
                label: <NavLink to="/income/prices">Narxlar</NavLink>,
            },
            {
                key: '/income/perenos',
                label: <NavLink to="/income/perenos">Perenos</NavLink>,
            }
        ]
    },
    {
        key: '/orders',
        icon: <UploadOutlined />,
        label: <NavLink to="/orders">Buyurtmalar</NavLink>,
    },
    {
        key: '/bts',
        icon: <CarOutlined />,
        label: <NavLink to="/bts">BTS yetkazib berish</NavLink>,
    },

    {
        key: '/teams',
        icon: <UserOutlined />,
        label: <NavLink to="/teams">Xodimlar</NavLink>,
    },
    {
        key: '/charts',
        icon: <PieChartOutlined />,
        label: <NavLink to="/charts">Statistika</NavLink>,
    },
    {
        key: '/params',
        icon: <PieChartOutlined />,
        label: <NavLink to="/params">Parametrlar</NavLink>,
        children: [
            {
                key: '/media',
                label: <NavLink to="/media">Media</NavLink>,
            },
            {
                key: '/params/brands',
                label: <NavLink to="/params/brands">Markalar</NavLink>,
            },
            {
                key: '/params/models',
                label: <NavLink to="/params/models">Modellar</NavLink>,
            },
            {
                key: '/params/countries',
                label: <NavLink to="/params/countries">Davlatlar</NavLink>,
            },
            {
                key: '/params/categories',
                label: <NavLink to="/params/categories">Kategoriyalar</NavLink>,
            },
            {
                key: '/params/manufacturers',
                label: <NavLink to="/params/manufacturers">Ishlab Chiqaruvchilar</NavLink>,
            },
            {
                key: '/params/colors',
                label: <NavLink to="/params/colors">Ranglar</NavLink>,
            },
            {
                key: '/params/units',
                label: <NavLink to="/params/units">O'lchovlar</NavLink>,
            },

            {
                key: '/params/configs',
                label: <NavLink to="/params/configs">Konfiguratsiyalar</NavLink>,
            },
            {
                key: '/params/shops',
                label: <NavLink to="/params/shops">Magazinlar</NavLink>,
            },

            {
                key: '/params/roles',
                label: <NavLink to="/params/roles">Mansablar</NavLink>,
            },
        ]
    },
    {
        key: 'site',
        icon: <PieChartOutlined />,
        label: <NavLink to="/site">Sayt sozlamalari</NavLink>,
        children: [
            {
                key: '/company',
                label: <NavLink to="/company">Korxona ma'lumotlari</NavLink>,
            },
            {
                key: '/sliders',
                label: <NavLink to="/sliders">Sliders</NavLink>,
            },
            {
                key: "comments",
                label: <NavLink to="/comments">Maxsulotlarga fikrlar</NavLink>,
            },
            {
                key: "discounts",
                label: <NavLink to="/discounts">Chegirmalar</NavLink>,
            }
        ]
    },
    {
        key: 'jurnal',
        icon: <PieChartOutlined />,
        label: <NavLink to="/jurnal">Jurnal</NavLink>,
    }
];
